export default class AppError {

	constructor (private message: string) {}

	public getMessage () {
		return this.message;
	}
}


// WEBPACK FOOTER //
// ./code/foundation/error/AppError.ts